import { commitmentsForTableSelector } from "../source/commitmentsForTableSelector";
import { RootState } from "../../../../../store";

export const commitmentsForTableLoadingSelector = (
  state: RootState,
): boolean => {
  return !!commitmentsForTableSelector(state)?.isLoading;
};
